import React, { useState } from 'react';
import { Form, Input, Button, Typography, Alert } from 'antd';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { authApi } from '../../services/portalApi';
import AuthCard from '../../components/AuthCard';
import zeroLogo from '../../assets/images/zero-logo-small.png';

export default function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);

  const onFinish = async ({ newPassword, confirm }) => {
    if (newPassword !== confirm) {
      setError('Passwords do not match');
      return;
    }
    setLoading(true);
    setError(null);
    try {
      await authApi.resetPassword(token, newPassword);
      setDone(true);
      setTimeout(() => navigate('/login'), 1500);
    } catch (err) {
      setError(err.response?.data?.message || 'Reset failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard foot={<Link to="/login">Back to sign in</Link>}>
      <div style={{ textAlign: 'center', marginBottom: 24 }}>
        <img src={zeroLogo} alt="Agent Zero" style={{ width: 44, height: 44, objectFit: 'contain' }} />
        <Typography.Title level={4} style={{ marginTop: 12, marginBottom: 0 }}>
          Set a new password
        </Typography.Title>
      </div>
      {!token ? (
        <Alert type="error" showIcon message="Missing reset token" description="Use the link from your email." />
      ) : done ? (
        <Alert type="success" showIcon message="Password reset" description="Redirecting you to sign in…" />
      ) : (
        <>
          {error && <Alert type="error" message={error} style={{ marginBottom: 16 }} showIcon />}
          <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
            <Form.Item
              name="newPassword"
              label="New password"
              rules={[{ required: true, min: 8, message: 'At least 8 characters' }]}
            >
              <Input.Password size="large" autoComplete="new-password" />
            </Form.Item>
            <Form.Item name="confirm" label="Confirm new password" rules={[{ required: true }]}>
              <Input.Password size="large" autoComplete="new-password" />
            </Form.Item>
            <Button type="primary" htmlType="submit" size="large" block loading={loading}>
              Reset password
            </Button>
          </Form>
        </>
      )}
    </AuthCard>
  );
}
